module.exports = __webpack_public_path__ + "img/AICM数字化智能会员营销方案.b9b4daed.png";